import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { InstallationCheckedPluginFactoryService } from './checked-plugin-factory.plugin';

@Injectable()
export class InstallationCheckedPluginService extends InspectionPluginService {
  public statusKeys: any = [
    { value: 1, label: 'plugins.installationchecked.checked' },
    { value: 2, label: 'plugins.installationchecked.not-checked' },
    { value: 3, label: 'plugins.installationchecked.to-be-corrected' }
  ];

  public statuses: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private checkedFactory: InstallationCheckedPluginFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateCheckedValues(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    checkedValues: any[]
  ): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, checkedValues).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getStatuses() {
    return this.statuses;
  }

  public applyTranslations() {
    this.statuses = [];
    this.copyTranslationValues(this.statusKeys, this.statuses, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, checkedValues: any[]): Observable<any> {
    return this.checkedFactory
      .updateCheckedValues(inspectionId, pointId, pluginId, checkedValues, 'CheckedValues')
      .pipe(
        flatMap((plugin) => {
          if (this.isInspectionInOffline(inspectionId)) {
            return of(plugin);
          }
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        })
      );
  }
}
